import React from 'react';

import { ContainerUac, Container, Content, IconContact } from './styles';
import { MdPermPhoneMsg } from 'react-icons/md';
function Uac() {
    return (

        <ContainerUac>
            <h2>Nossos telefones</h2>
            <Container>
                <IconContact>
                    <MdPermPhoneMsg size={52} />
                </IconContact>
                <div>
                    <Content>
                        <div>
                            <p>
                                Regiões Metropolitanas:<br />
                                <a href="tel:40031616">4003-1616</a>
                            </p>
                            <p>
                                Demais regiões:<br />
                                <a href="tel:08008861616">0800-886-1616</a>
                            </p>
                        </div>
                    </Content>
                </div>
            </Container>
        </ContainerUac>

    );
}

export default Uac;